import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React from 'react'

const subnavLoadingCss = css`
  height: 52px;
  background: ${colors.gray00};
`

export default function SubnavLoading(): JSX.Element {
  return <nav css={subnavLoadingCss} aria-hidden="true" />
}
